import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";

const DocNotifications = () => {
  const navigate = useNavigate();

  const [docsAccepted, setDocsAccepted] = useState(null);

  useEffect(() => {
    const cookie_accepted = Cookies.get('docs_accepted');
    if(String(cookie_accepted) == "1") {
      setDocsAccepted(true);
    } else {
      setDocsAccepted(false);
    }
  }, []);

  function clickAcceptDocs() {
    Cookies.set('docs_accepted', "1", { expires: 90, path: '/'});
    setDocsAccepted(true);
  }
  

  return (
    <>
      {docsAccepted === false && (
        <div className="fixed bottom-0 w-full" style={{zIndex: 1}}>
          <div className="w-full bg-gray-800 px-4 py-6 flex flex-col md:flex-row justify-between font-regular text-white z-40 space-y-4 md:space-y-0 md:space-x-4">
            <div className="text-left xl:max-w-[80%]">
              <p className="text-lg font-bold">This website uses cookies</p>
              <p className="text-xs">{'This website uses cookies to improve user experience and for personalization of ads. By clicking "Accept All", you agree to the use of cookies as described in our policy.'} <span className="underline cursor-pointer" onClick={() => navigate(`/docs/cookie-policy`)}>Read More</span></p>
              
              <p className="text-lg font-bold mt-2">Terms of Service and Privacy Policy</p>
              <p className="text-xs">By using the service, you confirm that you have read and agree to the <span className="underline cursor-pointer" onClick={() => navigate(`/docs/terms`)}>Terms of Service</span> and <span className="underline cursor-pointer" onClick={() => navigate(`/docs/privacy-policy`)}>Privacy Policy</span> and you acknowledge that we are not responsible for any financial outcomes resulting from your use of our platform.</p>
            </div>
            <div className="text-right flex justify-center items-center">
              <button className="bg-blue-400 px-8 py-2 font-bold text-md rounded-md" onClick={() => clickAcceptDocs()}>Accept All</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DocNotifications;